<template>
  <div id="client">

    <!-- * Title -->
    <div class="title">
      {{$t("add_client")}}
    </div>

    <!-- * Form Fields -->
    <div class="fields">
      <div class="field">
        <label>{{$t('name')}}</label>
        <input type="text" v-model="client.description"/>
      </div>
      <div class="field">
        <label>{{$t('email')}}</label>
        <input type="text" v-model="client.email"/>
      </div>
      <div class="field">
        <label>{{$t("company")}}</label>
          <multiselect v-model="companyObjects" :options="userData.user.groups" label="name" track-by="id" :multiple="true"
            :close-on-select="false" :preserve-search="true" :preselect-first="false"
            :placeholder="$t('select_companies')" :selectLabel="$t('select_company')"
            :selectedLabel="$t('selected_company')" :deselectLabel="$t('deselect_company')">
            <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single"
                v-if="values.length" v-show="!isOpen">{{ values.length }} {{ $t('companies_selected') }}</span></template>
          </multiselect>
      </div>
    </div>

    <!-- * Buttons -->
    <div class="buttons">
      <button class="btn-green" @click="save()">{{$t('save')}}</button>
      <button class="btn-black" @click="$emit('close')">{{$t('cancel')}}</button>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import Modal from './../components/Modal'
import {mapActions, mapState} from 'vuex'
export default {
  name: 'add-client',
  props: ['id'],
  components: {
    Multiselect,
    Modal
  },
  mounted () {
    this.getClientInfo()
  },
  data () {
    return {
      client: {
        description: '',
        email: '',
        company: []
      }
    }
  },
  computed: {
    ...mapState({
      userData: state => state.auth.userData
    }),
    companyObjects: {
      get () {
        let companyArray = this.client.company
        companyArray = companyArray ? (!Array.isArray(companyArray) ? [companyArray] : companyArray) : []

        return companyArray.map(id => {
          return this.userData.user.groups.find(group => group.id === id) || { id, name: 'Unknown' }
        })
      },
      set (newValues) {
        this.client.company = newValues.map(company => company.id)
      }
    }
  },
  watch: {
    id () {
      if (this.id) this.getClients(this.id).then(response => { this.client = response })
    },
    companyId (newVal) {
      if (newVal) {
        this.getCompany({ id: newVal }).then(response => {
          this.isTrw = response[0].is_trw
        })
      }
    }
  },
  methods: {
    ...mapActions({
      getCompany: 'listes/company',
      saveClient: 'clients/save',
      getClient: 'clients/read'
    }),
    save () {
      var client = JSON.parse(JSON.stringify(this.client))

      this.saveClient(client).then(() => {
        this.client = {}
        this.$emit('close')
        this.$emit('refreshClients')
      }).catch((error) => {
        console.error('Error saving client:', error)
      })
    },

    // Async methods
    async getInitialData () {
      this.client = this.id ? await this.getClient(this.id) : this.client
    },
    async checkCompany () {
      if (this.companyId) {
        const companyResponse = await this.getCompany({ id: this.companyId })
        this.isTrw = companyResponse && companyResponse.length > 0 ? companyResponse[0].is_trw : this.isTrw
      }
    },
    async getClientInfo () {
      try {
        await this.checkCompany()
        await this.getInitialData()
        console.log('Client:', this.client)
      } catch (error) {
        console.error('Error checking permissions and company:', error)
      } finally {
        this.$emit('loaded')
      }
    }
  }
}
</script>

<style scoped>
/* Estilos generales para el modal */
#client {
  gap: 2rem;
  padding: 2rem;
  background-color: #f9f9f9;
  border-radius: 1rem;
  box-shadow: 0px 8px 20px rgba(0, 0, 0, 0.1);
}
input, .input-class{
  width: 100%;
  box-sizing: border-box;
}
.fields {
  padding: 0 3em;
}
.buttons {
  display: flex;
  justify-content: center;
  margin-top: 1em;
  gap: 10px;
  .btn-green:hover {
    background-color: #e8ee8f;
  }
  .btn-blue:hover {
    background-color: #5ab9b9;
  }
  .btn-black:hover {
    background-color: #5e5e5e;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Client.vue